import { render, staticRenderFns } from "./PhoFileInput.vue?vue&type=template&id=5b7f4cd8&lang=pug"
import script from "./PhoFileInput.vue?vue&type=script&lang=js"
export * from "./PhoFileInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports